'use client';

import { neutralDarkColor, neutralLightColor, surfaceLightColor, surfaceDarkColor } from "../color.css.js";
import { hasContrast } from "./hasContrast.js";
const getActionSafe = (context, primaryPalette) => {
  const isOnLight = context === "onLight";
  if (isOnLight) {
    if (hasContrast(surfaceLightColor, primaryPalette.dark, true))
      return primaryPalette.dark;
    if (hasContrast(surfaceLightColor, primaryPalette.darkest, true))
      return primaryPalette.darkest;
    return neutralDarkColor;
  }
  if (hasContrast(surfaceDarkColor, primaryPalette.base, true))
    return primaryPalette.base;
  if (hasContrast(surfaceDarkColor, primaryPalette.light, true))
    return primaryPalette.light;
  if (hasContrast(surfaceDarkColor, primaryPalette.lightest, true))
    return primaryPalette.lightest;
  return neutralLightColor;
};
export {
  getActionSafe
};
